import { ScrollView, StyleSheet, Text, View } from "react-native";
import { Row, Table } from "react-native-table-component";
import Icon from "react-native-vector-icons/MaterialCommunityIcons";
import PageTitle from "../../../components/PageTitle";
import { formatHour, formatMoneyBRL } from "../../../helpers/util";
import * as Colors from "../../../styles/colors";
import * as Fonts from "../../../styles/typography";

export default function ProporcionalTable({ navigation, route }) {
    const params = route.params
    const tablePrice = params.tablePrice
    const tablePriceProportional = params.proportionalTable
    const totalPerSpace = isNaN(tablePrice.price) ? 0 : tablePriceProportional[0].grossPrice
    const daysOfWeek = []


    tablePrice.daysOfWeek.split(" ").map((day, index) => {
        daysOfWeek.push(day)
    })


    const dayDiscount = tablePriceProportional[0].payday ? tablePriceProportional[0].payday : 0 //params.tablePrice.dueDate
    const cutDay = dayDiscount == 1 ? 15 : 20

    const percentualDiscount = tablePriceProportional[0].discount ? tablePriceProportional[0].discount : 0
    const percentualAdditional = 2
    const totalPerSpaceWithDiscount = totalPerSpace - (percentualDiscount * totalPerSpace / 100)
    const totalPerSpaceWithAdditional = totalPerSpace + (percentualAdditional * totalPerSpace / 100)
    const tableHead = ['Dia', 'Ínicio', 'Fim']


    return <PageTitle title={"Informações da tabela"} navigation={navigation}>
        <View style={styles.viewIcon}>
            <Icon size={32} name={"calendar-month-outline"} />
            <Text style={styles.unityName}>{tablePrice.name}</Text>
        </View>
        <View style={styles.viewSubdata}>
            <View style={styles.totalView}>
                <Text style={styles.totalText}>{"Valor por vaga"}</Text>
                <Text style={styles.valueText}>
                    {formatMoneyBRL(totalPerSpace)}
                </Text>
            </View>
            <View
                style={{
                    flexDirection: "row",
                    justifyContent: "space-around",
                    width: "100%",
                }}
            >
                <View style={styles.totalView}>
                    <Text style={styles.totalText}>{`Pagando até dia ${dayDiscount.toString().padStart(2, "0")}`}</Text>
                    <Text style={[styles.totalText, { fontWeight: "400" }]}>{`Desconto de ${percentualDiscount}%`}</Text>
                    <Text style={styles.valueText}>{formatMoneyBRL(totalPerSpaceWithDiscount)}</Text>
                </View>
                <View style={styles.totalView}>
                    <Text style={styles.totalText}>{"Pagando em atraso"}</Text>
                    <Text style={[styles.totalText, { fontWeight: "400" }]}>{`Acréscimo de ${percentualAdditional}%`}</Text>
                    <Text style={styles.valueText}>{formatMoneyBRL(totalPerSpaceWithAdditional)}</Text>
                </View>
            </View>
        </View>
        <Text style={styles.titleText}>{"DIAS DA SEMANA"}</Text>
        <Table style={{ marginTop: 8 }}>
            <Row data={tableHead} style={table.head} textStyle={table.text} />
        </Table>
        <ScrollView
            style={{ width: "100%", marginVertical: 8 }}
        >
            <Table>
                {daysOfWeek.map((dayOfWeek, index) => {
                    let startTime = tablePrice.startTime
                    let endTime = tablePrice.endTime
                    let dayName = dayOfWeek == "FE" ? "Feriado" : dayOfWeek
                    if (dayOfWeek == "SAB" || dayOfWeek == "DOM") {
                        startTime = tablePrice.startTimeWeekend
                        endTime = tablePrice.endTimeWeekend
                    }
                    const rowData = [dayName, formatHour(startTime), formatHour(endTime)]
                    return <Row data={rowData} textStyle={table.textValue} style={rowData[0] == cutDay ? table.cellValueCutDay : table.cellValue} key={index} />
                })}
            </Table>
        </ScrollView>
        <View style={styles.infoView}>
            <Text style={styles.titleText}>{"PROPORCIONAL POR DIA"}</Text>
            <View
                style={{
                    flexDirection: "row",
                    alignItems: "center",
                    marginLeft: "auto",
                }}
            >
                <Icon
                    name="chevron-right"
                    size={28}
                    onPress={() => {
                        if (totalPerSpace > 0) navigation.navigate("ProportionalTable", { tableDataItems: tablePriceProportional, cutDay: cutDay, netValue: totalPerSpaceWithDiscount })
                    }}
                />
            </View>
        </View>
    </PageTitle >
}



const styles = StyleSheet.create({
    viewSubdata: {
        padding: 4,
        backgroundColor: Colors.SNOW,
        borderColor: Colors.SECONDARY,
        borderLeftWidth: 2,
        shadowColor: Colors.GRAY_DARK,
        shadowOffset: {
            width: 0,
            height: 2,
        },
    },
    titleText: {
        color: Colors.SECONDARY,
        fontSize: Fonts.FONT_SIZE_16,
        fontWeight: "bold",
        marginVertical: 8,
    },
    totalText: {
        fontWeight: "bold",
        fontSize: Fonts.FONT_SIZE_16,
    },
    valueText: {
        fontSize: Fonts.FONT_SIZE_16,
        color: Colors.PRIMARY,
    },
    totalView: {
        justifyContent: "center",
        alignItems: "center",
    },
    warning: {
        fontSize: Fonts.FONT_SIZE_16,
        color: Colors.SECONDARY,
        fontWeight: "500",
        textAlign: "center"
    },
    infoView: {
        flexDirection: "row",
        alignItems: "center",
        backgroundColor: Colors.GRAY_LIGHT,
        borderRadius: 8,
        marginVertical: 16,
        padding: 8,
        borderLeftWidth: 2,
        borderTopLeftRadius: 0,
        borderBottomStartRadius: 0,
        borderColor: Colors.SECONDARY,
    },
    viewIcon: {
        alignItems: "center",
        justifyContent: "center",
        padding: 8,
        flexDirection: "row",
      },
      unityName: {
        fontSize: Fonts.FONT_SIZE_16,
        marginLeft: 4,
      },
})

const table = StyleSheet.create({
    head: { height: 40, backgroundColor: Colors.SECONDARY, borderRadius: 5 },
    text: { margin: 6, fontSize: Fonts.FONT_SIZE_16, color: Colors.SNOW, fontWeight: "500" },
    textValue: { margin: 6, fontSize: Fonts.FONT_SIZE_16 },
    cellValue: { borderBottomWidth: 1, borderColor: Colors.SECONDARY },
    cellValueCutDay: { borderBottomWidth: 1, borderColor: Colors.SECONDARY, backgroundColor: Colors.GRAY_MEDIUM }
});